import { Component, Input, OnInit } from '@angular/core';
import { enumIdentifierQualifier } from '@data-layer/enums/common';

import { FormHelper } from '@helpers/form.helper';
import { enumEntityModelCode } from '@data-layer/enums/entities';
import { EntityModel } from '@data-layer/models/entities';
import { EntityValidationHelper } from '@helpers/entity-validation.helper';

@Component({
  selector: 'isf-entity-details',
  templateUrl: './isf-entity-details.component.html',
  styleUrls: ['./isf-entity-details.component.scss'],
})
export class IsfEntityDetailsComponent implements OnInit {
  @Input() public isfEntity: EntityModel;
  @Input() public code: enumEntityModelCode;

  public isShowIdentifierBlock: boolean = true;
  public enumEntityModelCode: typeof enumEntityModelCode = enumEntityModelCode;

  constructor(private fh: FormHelper) {}

  public ngOnInit(): void {
    this.isShowIdentifierBlock = !this.checkShowIdentifierBlock();
  }

  public getValidationText(isfEntity: EntityModel, field: string) {
    return EntityValidationHelper.entityGetSummaryValidationText(isfEntity, field);
  }

  public isValidIsfEntityAddress(): boolean {
    return this.fh.isValidIsfEntityAddress(this.isfEntity.address);
  }

  public isMissingIsfEntityAddressParts(): boolean {
    return this.fh.isMissingIsfEntityAddressParts(this.isfEntity.address);
  }

  private checkShowIdentifierBlock(): boolean {
    const isHideV =
      [
        enumEntityModelCode.SHIP_TO,
        enumEntityModelCode.MANUFACTURER,
        enumEntityModelCode.STAFFING_LOCATION,
        enumEntityModelCode.CONSOLIDATOR,
        enumEntityModelCode.BUYER,
      ].indexOf(this.code) !== -1;

    return (
      (this.isfEntity.entityIdentifierQualifier === enumIdentifierQualifier.EIN ||
        this.isfEntity.entityIdentifierQualifier === enumIdentifierQualifier.SSN) &&
      isHideV
    );
  }
}
